interface ProcessTypeProps {
  processType: string;
}

const processTypeMapper: Record<string, string> = {
  aprobologia: 'Aprobología',
  aprobologia_reintentado: 'Reintento por comercial',
  price_adjustment_by_approver: 'Reintento Ajuste de Precio',
  retry_pricing_committee_by_approver: 'Reintento Repricing Comité',
};

export const ProcessType = ({ processType }: ProcessTypeProps) => {
  const label = processTypeMapper[processType] ?? processType;
  return <div>{label}</div>;
};
